angular.module("correspondences_types")

    .controller("CorrespondencesTypesEditCtrl", ['LoginService', '$scope', '$rootScope', '$state', '$stateParams', 'Restangular', '$filter', 'modalService', function (LoginService, $scope, $rootScope, $state, $stateParams, Restangular, $filter, modalService) {
        
        //Comprobamos si tiene permiso escritura
        $scope.allowWrite = LoginService.permissionExist("CORRESPONDENCE_TYPE_WRITE");
        $rootScope.title = $filter('translate')('correspondences_types.title');

        $scope.correspondence_type = {};
        $scope.selectEntityTypes = [{ id: 'events', name: $filter("translate")('entity_types.events') }, { id: 'correspondence', name: $filter("translate")('entity_types.correspondence') }];;

        if (angular.isUndefined($stateParams.id) || $stateParams.id == "") {
       
            $rootScope.breadcrumb = [
                { title: $filter('translate')('correspondences_types.title'), url: "correspondences_types.list" },
                { title: $filter('translate')('correspondences_types.title_add') },
            ];
             
        } else {
            $rootScope.breadcrumb = [
                { title: $filter('translate')('correspondences_types.title'), url: "correspondences_types.list" },
                { title: $filter('translate')('correspondences_types.title_edit') },
            ];

            Restangular.one('CorrespondencesTypes', $stateParams.id).get().then(function (result) {
                
                $scope.correspondence_type = result;                
            });
        }               
                                       
            $scope.save = function () {            
            if (angular.isDefined($scope.correspondence_type.id)) {
                $scope.correspondence_type.put().then(function (result) {
                    if (angular.isDefined(result.id)) {
                        toastr.success($filter('translate')('correspondences_types.edit_success'));                        
                        $state.go("correspondences_types.list");
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            } else {
                Restangular.all('CorrespondencesTypes').post($scope.correspondence_type).then(function (result) {
                    if (angular.isDefined(result.id)) {
                        toastr.success($filter('translate')('correspondences_types.save_success'));
                        $state.go("correspondences_types.list");
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            }
        }

        $scope.checkDelete = function () {
            modalService.confirm({
                title: $filter('translate')('correspondences_types.button_delete'),
                message: $filter('translate')('correspondences_types.delete_message') + " " + $scope.correspondence_type.name + "?",
                onAccept: function () {
                    $scope.correspondence_type.remove().then(function () {
                        toastr.success($filter('translate')('correspondences_types.deleted_success'));
                        $state.go("correspondences_types.list");
                    });
                }
            });
        };        

}])

;

